
const products = [
  {
    imgUrl: 'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FMini%2520Banner%2520Eafc%252024-28da1ccb-f7d3-4047-986a-2eb00efb2dc8.jpg&w=1920&q=75',
    title: "Intel Gaming Weekends Croma Bengaluru (EAFC)",
    mode: 'Game Mode: Single Elimination',
    platform: 'Platform:',
    prize: "100000000",
    participants: "8 of 128",
    status: "PAST",
    date: "20 May 2023",
    link: "/xyz-tro-123" , 
    country:"Countries",
    bannerUrl:'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FMain%2520Banner%2520Eafc%252024-27939961-cada-4e46-a9f3-4a33fce0043d.jpg&w=1920&q=75',
    tourend:'Tournament ends in 1 day',
    tourhost:'Hosted by ',
    game:' EAFC 24',
    teamsize:'3+1',
    prize:'1,00,000 INR',
    format:'Single Elimination',
    registerstart:'September 6th 24, 9:45 pm',
    registerend:'September 15th 24, 10:30 am',
    tournamentstart:'September 15th 24, 11:00 am',
    tournamentend:'September 15th 24, 6:00 pm'
    ,id:"13"
  },
  {
    imgUrl: 'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FSMALL%2520banner-3e66b3f5-352d-4eb0-8c02-e730c68c274e.png&w=1920&q=75',
    title: "TEC Bed Wars - Roblox",
    mode: 'Game Mode: Single Elimination',
    platform: 'Platform:',
    prize: "100000000",
    participants: "8 of 128",
    status: "PAST",
    date: "12 Sept 2024",
    link: "/xyz-tro-123",
    country:"Countries",
    bannerUrl:'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FBIG%2520banner-b5f8bf93-247b-44b2-904c-0f2a350267da.png&w=1920&q=75',
    tourend:'Tournament ends in 1 day',
    tourhost:'Hosted by ',
    game:' Roblox',
    teamsize:'2-0',
    prize:'10K Robux',
    format:'Single Elimination',
    registerstart:'August 12th 24, 2:45 pm',
    registerend:'August 15th 24, 5:10 pm',
    tournamentstart:'August 18th 24, 4:00 pm',
    tournamentend:'August 18th 24, 8:00 pm'
    ,id:"14"
  },
  {
    imgUrl: 'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FFC24_Weekend_League_WebSMALL-banner-1f76ca83-f447-4699-a58d-8636a5f6cac8.png&w=1920&q=75',
    title: "Viewsonic Gaming Weekend League - Mumbai",
    mode: 'Game Mode: Single Elimination',
    platform: 'Platform:',
    prize: "100000000",
    participants: "8 of 128",
    status: "PAST",
    date: "1 Jan 2024",
    link: "/xyz-tro-123",
    country:"Countries",
    bannerUrl:'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FFC24_Weekend_League_WebBIG-banner-f8ffb586-2401-4459-b8d7-8574794d9b1e.png&w=1920&q=75',
    tourend:'Tournament ends in 1 day',
    tourhost:'Hosted by ',
    game:' FC24',
    teamsize:'NA',
    prize:'VX2479-HD-PRO 24" 165 Hz Gaming Monitor (Only for 1st Place)',
    format:'Single Elimination',
    registerstart:'August 7th 24, 7:39 pm',
    registerend:'August 17th 24, 1:00 pm',
    tournamentstart:'August 17th 24, 1:01 pm',
    tournamentend:'August 17th 24, 6:00 pm'
    ,id:"15"
  },
  {
      imgUrl: 'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FSMALL%2520banner-c4cb6651-717b-4a26-9843-d9e20c718c89.png&w=1920&q=75',
      title: "TEC Community Cup - August Open",
      mode: 'Game Mode: Single Elimination',
      platform: 'Platform:',
      prize: "100000000",
      participants: "8 of 128",
      status: "PAST",
      date: "2 May 2024",
      link: "/xyz-tro-123",
      country:"Countries",
      bannerUrl:'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FBIG%2520banner-b2cf0539-b686-48d5-b43a-d27fdeb63244.png&w=1920&q=75',
      tourend:'Tournament ends in 1 day',
      tourhost:'Hosted by ',
      game:' Valorant TDM ',
      teamsize:'NA',
      prize:'40,000 INR Worths of Amazon Vouchers',
      format:'Double Elimination',
      registerstart:'August 1st 24, 11:03 am',
      registerend:'August 14th 24, 6:00 pm',
      tournamentstart:'August 15th 24, 12:00 pm',
      tournamentend:'August 25th 24, 10:00 pm'
      ,id:"16"

    },
    {
      imgUrl: 'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FMini%2520Banner-96d5cd5a-d30b-4e67-b333-3d4d17bbc043.png&w=1920&q=75',
      title: "Alienware Arena - B.K. Birla College of Arts, Science and Commerce, Mumbai",
      mode: 'Game Mode: Single Elimination',
      platform: 'Platform:',
      prize: "10,000 INR",
      participants: "8 of 128",
      status: "PAST",
      date: "9 Feb 2023",
      link: "/xyz-tro-123" ,
      country:"Countries",
      bannerUrl:'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FMain%2520Banner-9269ac31-29fc-431a-8615-a057b48c1d4f.png&w=1920&q=75',
      tourend:'Tournament ends in 1 day',
      tourhost:'Hosted by ',
      game:'Valorant',
      teamsize:'NA',
      prize:'10,000 INR',
      format:'Single Elimination',
      registerstart:'August 7th 24, 6:35 pm',
      registerend:'August 8th 24, 2:30 pm',
      tournamentstart:'August 8th 24, 2:40 pm',
      tournamentend:'August 8th 24, 8:00 pm'
      ,id:"17"
    },
    {
      imgUrl: 'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FValo%2520Small-62619d41-9df2-4136-89d3-fd21aadf0a81.jpg&w=1920&q=75',
      title: "Lenovo LOQ Play2Slay - Kanpur",
      mode: 'Game Mode: Single Elimination',
      platform: 'Platform:',
      prize: "100000000",
      participants: "8 of 128",
      status: "PAST",
      date: "5 Sept 2024",
      link: "/xyz-tro-123" ,
      country:"Countries",
      bannerUrl:'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FValo%2520BIG-b8956bc2-5a25-4a98-bd68-be5126edb344.jpg&w=1920&q=75',
      tourend:'Tournament ends in 1 day',
      tourhost:'Hosted by ',
      game:' BattleGROUNDS ',
      teamsize:'NA',
      prize:'1,00,000 INR',
      format:'Battle Royale',
      registerstart:'July 23rd 24, 6:20 pm',
      registerend:'August 24th 24, 12:15 pm',
      tournamentstart:'August 24th 24, 1:01 pm',
      tournamentend:'August 24th 24, 5:00 pm'
      ,id:"18"
    }

];

export{
  products
}